import { createContext, useContext } from 'react';
import { MessageContextType } from './types'; 

/**
 * MessageContext - 用于在 MessageCenter 组件内共享通用数据和方法
 */
export const MessageContext = createContext<MessageContextType | null>(null);

/**
 * useMessageContext - 获取当前上下文中的通用数据和方法
 * 必须在 <MessageContext.Provider> 中使用
 */
export const useMessageContext = () => {
  const ctx = useContext(MessageContext);
  if (!ctx) {
    throw new Error('useMessageContext must be used within a <MessageContext.Provider>');
  }
  return ctx;
};